import { createContext, useContext, useState } from 'react';

const FavoritesContext = createContext();

export const FavoritesProvider = ({ children }) => {
    const [favorites, setFavorites] = useState([]);

    const toggleFavorite = (meal) => {
        setFavorites((prev) => {
            const isAlreadyFav = prev.find((m) => m.idMeal === meal.idMeal);
            if(isAlreadyFav){
                return prev.filter((m) => m.idMeal !== meal.idMeal);
            }else{
                return [...prev, meal];
            
            }

        });
    };

    const isFavorite = (id) => {
        return favorites.some((m) => m.idMeal === id);
    };

    return (
        <FavoritesContext.Provider value={{ favorites, toggleFavorite, isFavorite }}>
            {children}
        </FavoritesContext.Provider>
    );
};

export const useFavorites = () => {
    const context = useContext(FavoritesContext);
    if (!context) {
        throw new Error('useFavorites must be used within a FavoritesProvider');
    }
    return context;
};